export const WHATSAPP_CHAT_URL = "https://wa.me/4915121676362";
export const WHATSAPP_CHAT_NUMBER = "+49 1512 1676362";
export const WHATSAPP_CHANNEL_URL = "https://whatsapp.com/channel/0029VavoRjv5fM5eIjz6LE3S";
export const INSTAGRAM_URL = "https://www.instagram.com/yobsti_marktplatz";
export const FACEBOOK_URL = "https://www.facebook.com/Yobsti";
export const NEWSLETTER_URL = "https://yobst-odoo.odoo.com/mailingliste";
